/* eslint-disable import/prefer-default-export */

// Source - https://stackoverflow.com/a/4819886
export function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-expect-error - msMaxTouchPoints exists in some browsers
    navigator.msMaxTouchPoints > 0
  );
}
